import Stack from '@mui/material/Stack';
import { Typography, useTheme } from '@mui/material';
import { NextPageButton } from '../../components/button/NextPageButton.tsx';
import { PageBackButton } from '../../components/button/pageBackButton.tsx';
import { useNavigate } from 'react-router';
import { Path } from '../../assets/enums/index.ts';
import { JuicyTypography } from '../../components/index.ts';
import { Button } from '../../components/button/index.ts';
import { useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import { useGameSessionContext } from '../../assets/helpers/hooks/index.ts';
import { gameNamesWrapperSx, getAmountButtonSx, getGameNameButtonSx, imgSx } from './styles.ts';
import { PlayerIcon } from '../../assets/icons/player.tsx';
import { LogoutIcon } from '../../assets/icons/logout.tsx';
import cup from '@assets/images/cup.webp';
const amounts = [
  5, 10, 20, 50, 100, 'Play for Free',
];

const mb = 8;
const gameNames = [
  'Hole-In-One', 'Inside 3 Metres', 'Inside 5 Metres',
];
export const GameSettingsPage = () => {
  const { setParams, gameSessionParams, clearGameSessionContext } = useGameSessionContext();

  const theme = useTheme();
  const { palette } = theme;
  const nav = useNavigate();

  const [gameName, setGameName] = useState(gameSessionParams?.gameName || gameNames[0]);
  const [amount, setAmount] = useState(gameSessionParams?.amount || amounts[0]);
  const isAuth = gameSessionParams?.phoneNumber;

  const onNextPageButtonClick = useCallback(() => {
    setParams({
      gameName,
      amount: typeof amount === 'number' ? amount : undefined,
    });
    nav(isAuth ? Path.PaymentMethod : Path.Phone);
  }, [setParams, gameName, nav, amount, isAuth]);
  const onLogoutButtonClick = useCallback(() => {
    clearGameSessionContext()
    nav(Path.Home);
  },[clearGameSessionContext, nav])
  return (
    <Stack height={'100%'} pt={20} pb={14} position={'relative'}>
      {isAuth && <Stack
        onClick={onLogoutButtonClick}
        sx={{
          position: 'absolute',
          top: 0,
          flexDirection: 'row',
          alignItems: 'center',
          width: 887,
          background: theme.palette.black_40,
          borderRadius: '0 0 32px 32px',
          p: 10,
        }}
      >
        <PlayerIcon style={{ width: '64px', height: '64px' }} color={palette.accent} />
        <Typography ml={4} variant={'body'} color={palette.accent}>{gameSessionParams.phoneNumber}</Typography>
        <LogoutIcon style={{ marginLeft: 'auto' }} color={palette.white_100} />
      </Stack>
      }
      <JuicyTypography mt={isAuth ? 30 : 0} mr={40} mb={isAuth ? 14 : 20}>Choose Your Challenge</JuicyTypography>

      <Typography variant={'title'} color={palette.white_90} mb={mb}>Hit it tight or hole it and win</Typography>

      <Stack direction="row" flexWrap={'wrap'} sx={gameNamesWrapperSx}>
        {gameNames.map((name, i) => {
          const isFirst = i === 0;
          const isActive = gameName === name;
          return (
            <Button
              key={name}
              onClick={() => setGameName(name)}
              variantStyle={'secondary'}
              sx={getGameNameButtonSx(theme, isFirst)}
              active={isActive}
            >
              {name}
            </Button>
          );
        })}
      </Stack>


      <Typography mt={isAuth ? 19.5 : 20.5} variant={'title'} color={palette.white_90} mb={mb}>Wager amount</Typography>

      <Stack direction="row" flexWrap="wrap" gap={6} px={1}>
        {amounts.map((el, i) => (
          <Button
            onClick={() => setAmount(el)}
            key={i}
            variantStyle="secondary"
            active={amount === el}
            sx={getAmountButtonSx(theme, amounts.length - 1 === i)}
          >
            {i !== amounts.length - 1 ? '$' : ''}
            {el}
          </Button>
        ))}
      </Stack>



      {typeof amount === 'number' &&
        <Stack direction={'row'} justifyContent={'space-between'} mt={isAuth ? 14 : 26.5}>
          <Stack gap={5}>
            <JuicyTypography variantStyle={'orange'} variant={'title'}>Prize Money</JuicyTypography>
            <JuicyTypography variantStyle={'orange'}
                             variant={'accent_alt'}>${Number(amount) * gameSessionParams.factor}</JuicyTypography>
          </Stack>
          <Box component={'img'} src={cup} sx={imgSx} />
        </Stack>
      }

      <Stack width="100%" mt="auto" direction={'row'} alignItems={'center'} gap={8}>
        <PageBackButton onClick={() => nav(Path.Home)} />
        <NextPageButton onClick={onNextPageButtonClick}>Continue</NextPageButton>
      </Stack>
    </Stack>
  );
};
